import {
  HOME_SAVE_PLANS_BEGIN,
  HOME_SAVE_PLANS_SUCCESS,
  HOME_SAVE_PLANS_FAILURE,
  HOME_SAVE_PLANS_DISMISS_ERROR,
} from './constants';

import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function savePlans(plans, savingId) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_SAVE_PLANS_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      axios.put("/api/plans/",plans).then(
        (res) => {
          dispatch({
            type: HOME_SAVE_PLANS_SUCCESS,
            data: {result: res.data, savingId}
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_SAVE_PLANS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSavePlansError() {
  return {
    type: HOME_SAVE_PLANS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_SAVE_PLANS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        savePlansPending: true,
        savePlansError: null,
      };

    case HOME_SAVE_PLANS_SUCCESS:
      // The request is success
      return {
        ...state,
        savePlansPending: false,
        savePlansError: null,
        savePlansSuccessIds: {
          ...state.savePlansSuccessIds,
          [action.data.savingId]: true
        }
      };

    case HOME_SAVE_PLANS_FAILURE:
      // The request is failed
      return {
        ...state,
        savePlansPending: false,
        savePlansError: action.data.error,
      };

    case HOME_SAVE_PLANS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        savePlansError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/savePlans.js